export default __webpack_public_path__ + "static/media/english.0e90cfdd.png";